(ns dashboard.views.browser-extension.questionnaire.config)

(def view-id :route.view/extension-questionnaire)
